const Logo = ({ variant = 'dark', size = 'md' }) => {
  const accent = '#00BCD4';
  const textColor = variant === 'dark' ? '#FFFFFF' : '#0A192F';
  const bodyFill = variant === 'dark' ? 'rgba(0,240,255,0.05)' : '#0A192F';
  const sz = size === 'sm' ? 0.75 : size === 'lg' ? 1.3 : 1;

  return (
    <div data-testid="logo" className="flex items-center gap-2 select-none" style={{ transform: `scale(${sz})`, transformOrigin: 'left center' }}>
      <svg width="44" height="50" viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Left wing */}
        <ellipse cx="13" cy="12" rx="11" ry="5" transform="rotate(-30 13 12)"
          fill={`${accent}18`} stroke={accent} strokeWidth="1.5"/>
        {/* Right wing */}
        <ellipse cx="31" cy="10" rx="11" ry="5" transform="rotate(30 31 10)"
          fill={`${accent}18`} stroke={accent} strokeWidth="1.5"/>
        {/* Body hexagon */}
        <polygon points="22,17 31,22 31,33 22,38 13,33 13,22"
          fill={bodyFill} stroke={accent} strokeWidth="1.5"/>
        {/* Stripes */}
        <line x1="14" y1="25.5" x2="30" y2="25.5" stroke={accent} strokeWidth="1.2" opacity="0.75"/>
        <line x1="14" y1="30.5" x2="30" y2="30.5" stroke={accent} strokeWidth="1.2" opacity="0.75"/>
        {/* Left antenna */}
        <line x1="18" y1="17" x2="11" y2="5" stroke={accent} strokeWidth="1.2"/>
        <circle cx="11" cy="4.5" r="2" fill={accent}/>
        {/* Right antenna */}
        <line x1="26" y1="17" x2="33" y2="5" stroke={accent} strokeWidth="1.2"/>
        <circle cx="33" cy="4.5" r="2" fill={accent}/>
        {/* Stinger */}
        <line x1="22" y1="38" x2="22" y2="46" stroke={accent} strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="22" y1="44" x2="19" y2="41" stroke={accent} strokeWidth="1.2" strokeLinecap="round"/>
        <line x1="22" y1="44" x2="25" y2="41" stroke={accent} strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
      <div style={{ fontFamily: 'Montserrat, sans-serif', lineHeight: 1 }}>
        <span style={{ color: accent, fontWeight: 900, fontSize: '20px', letterSpacing: '-0.5px' }}>BEE</span>
        <span style={{ color: textColor, fontWeight: 700, fontSize: '20px', letterSpacing: '-0.5px' }}>-ADVISED</span>
      </div>
    </div>
  );
};

export default Logo;
